import React from "react";
import { Row, Col } from "antd";
import { Metrics } from "../../theme/";
import { isAlive, ArrayUtil, OrgUtil, ColorUtil } from "../../util/";
import { GraphCardStyleContext, getSplitRatio } from "./GraphCard";
import { withTheme } from "styled-components";
export const CompareRow = ({style, primary, secondary, margin = true})=>{
	const isCompare = isAlive(secondary);
	return <Row style={style} gutter={Metrics.button.bigSpaceMargin}>
		<ShortColumn isCompare={isCompare} single={!isCompare} margin={margin}>
			{primary}
		</ShortColumn>
		{secondary ? <ShortColumn isCompare={isCompare} margin={margin}>
			{secondary}
		</ShortColumn> : undefined}
	</Row>;
};
const ShortColumn = ({children, style, isCompare, onClick = undefined, single = false, margin = true})=>{
	let addedStyle = style;
	if(margin){
		addedStyle = {
			...style,
			marginBottom: Metrics.button.bigSpaceMargin
		};
	}
	return (<Col 
		style={addedStyle}
		xs={single ? 24 : 12} 
		xxl={single ? 24 : (isCompare ? 12 : 8)}>
		<div onClick={onClick}>
			{children}
		</div>
	</Col>);
};
/**
 * Combine key object to category key.
 * @param {array} keys 
 */
export const combineKeyWithCategory = (keys)=>{
	const combineKeys = {...keys};
	OrgUtil.getAllCategoryName().forEach(k=>{
		combineKeys[k] = k;
	});
	return combineKeys;
};
export const IgnoreGraphKeys = [
	"date_range"
];

export const GraphProvider = withTheme((props)=>{
	const {
		isVertical, colorType, short, 
		showArrow, children, 
		hilight, theme
	} = props;
	const hilightColor = ColorUtil.getVisualizeColor(theme, colorType, 0, 0);
	return (<GraphCardStyleContext.Provider value={{
		...props,
		height: short ? 200 : undefined, showArrow,
		hilightColor,
		chartWidthRatio: getSplitRatio(short),
	}}>
		{children}
	</GraphCardStyleContext.Provider>);
});;

export default ({ 
	container,
	mutateSummary = {}, 
	mutatePreviousSummary = {},
	onClick,
	colorType, isVertical, noRow = false,
	beforeCol, afterCol, short, children, single = false, 
	showLegend = true, showValue = true,
	dateRange,
	pick,
	headKeys = [],
	supportGraphKeys,
	ignoreKeys = IgnoreGraphKeys,
	exclude = [], 
	hilightKey,
	drawEach,
	pushOnTypeClick,
	translate,
})=>{
	if(!isAlive(mutateSummary)){
		return null;
	}
	const DrawEach = drawEach;
	let sumKeys = Object.keys(mutateSummary).filter(k=>(
		supportGraphKeys.includes(k) && exclude.indexOf(k) === -1
	));
	let head = [];
	let tail = [];
	const date_range = mutateSummary["date_range"];
	headKeys.forEach(k=>{
		const index = sumKeys.indexOf(k);
		if(index !== -1){
			head.push(sumKeys.splice(index,1)[0]);
		}
	});
	sumKeys.forEach(key => {
		const lowerKey = key.toLowerCase();
		if(supportGraphKeys.indexOf(lowerKey) !== -1){
			head.push(key);
		}else if(ignoreKeys.indexOf(lowerKey) === -1){
			tail.push(key);
		}
	});
	sumKeys = head.concat(tail);
	if(pick !== undefined){
		sumKeys = [pick];
	}
	const height = short ? 200 : undefined;
	const cols = [];
	sumKeys.forEach((key,index)=>{
		if(mutateSummary[key] === undefined){
			return null;
		}
		if(isAlive(exclude)){
			if(ArrayUtil.isAliveArray(exclude)){
				if(exclude.indexOf(key) !== -1)
					return null;
			}else if(exclude === key){
				return null;
			}
		}
		let doDraw = false;
		const graph = <GraphProvider isVertical={isVertical} short={short} colorType={colorType} hilight={pick===key}>
			{(doDraw = <DrawEach typeKey={key} 
				object={mutateSummary[key]} 
				previousObject={mutatePreviousSummary[key]}
				dateRange={dateRange}
				isVertical={isVertical} colorType={colorType} showLegend={showLegend}
				short={short} height={height} showValue={showValue} 
				single = {single}
				pushOnTypeClick={pushOnTypeClick}
				translate={translate}
				hilight={ArrayUtil.isAliveArray(hilightKey) ? hilightKey.indexOf(key) !== -1 : false}
				onClick={onClick ? (item)=>{
					onClick({key, item});
				} : undefined}
			/>)}
		</GraphProvider>;
		if(doDraw !== null){
			cols.push(
				<ShortColumn key={index} single = {single} isCompare={isVertical} >
					{graph}
				</ShortColumn>
			);
		}
	});
	if(noRow){
		return <React.Fragment>
			{beforeCol}
			{cols}
			{children}
			{afterCol}
		</React.Fragment>;
	}
	return <Row gutter={Metrics.button.bigSpaceMargin}>
		{beforeCol}
		{cols}
		{children}
		{afterCol}
	</Row>;
};


// WEBPACK FOOTER //
// ./src/components/report/GenericGraphDrawer.js